/* src/app/private/components/leads/delete-lead/delete-lead.component.scss */
/*# sourceMappingURL=delete-lead.component.css.map */
